import React from 'react'
import styles from './EstimatedValueZeroState.module.scss'
import BotHead from 'src/Components/shared/Avatar/BotHeadColored'
import { FormattedMessage } from 'react-intl'
import { Panel, Text } from 'src/Components'

const EstimatedValueZeroState = ({ customerProfile }) => {
  return (
    <Panel data-qa='EstimatedValueZeroState' className={styles.container}>
      <Text.Headline className={styles.heading}>
        <FormattedMessage
          id='Homeowner.estimatedValue.zeroState'
          defaultMessage="What's your home worth?"
        />
      </Text.Headline>
      <div className={styles.messagingContainer}>
        <div className={styles.peekTop}>
          <BotHead quizzical type='danger' className={styles.peekTopAvatar} />
        </div>
        <Text color='white' size='l' align='center' paragraph>
          <FormattedMessage
            id='Homeowner.estimatedValue.zeroState.trouble'
            defaultMessage="We're having a little trouble gathering enough data to calculate an accurate value"
          />
        </Text>
        <Text color='quiet' size='s' align='center'>
          <FormattedMessage
            id='Homeowner.estimatedValue.zeroState.notifiedNewKey'
            defaultMessage="Don't worry, {firstName} is on the case! {firstName} has been notified and we'll get to the work on resolving your home details!"
            values={{
              firstName: customerProfile.firstName
            }}
          />
        </Text>
      </div>
    </Panel>
  )
}

export default EstimatedValueZeroState
